type Orderable = { number: number | null };

/** Squad list order: shirt number ascending, players without a number last. */
export function byNumber(a: Orderable, b: Orderable): number {
  return (a.number ?? 999) - (b.number ?? 999);
}
